import React, { useState, useEffect } from "react";
import hubspot from "../Images/IntegrationCompanyImages/hubspot.svg";
import pipedrive from "../Images/IntegrationCompanyImages/pipedrive.svg";
import zapier from "../Images/IntegrationCompanyImages/zapier.svg";
import calendly from "../Images/IntegrationCompanyImages/calendly.svg";
import make from "../Images/IntegrationCompanyImages/make.svg";
import hypersie from "../Images/IntegrationCompanyImages/hypersie.svg";
import linkedhelper from "../Images/IntegrationCompanyImages/linkedhelper.svg";
import phantombuster from "../Images/IntegrationCompanyImages/phantombuster.svg";
import weblium from "../Images/IntegrationCompanyImages/weblium.svg";
import salesforce from "../Images/IntegrationCompanyImages/salesforce.svg";
import Modal from "@mui/material/Modal";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../Loader";
import SpfGenerator from "./SpfGenerator";
const data = [
  {
    id: 1,
    img: calendly,
    subTitle:
      "The best automated scheduling software for online appointments. Avoid double- bookings and email back-and-forth with easy one-click scheduling",
    btnText: "Connect",
    active: false,
  },
  {
    id: 2,
    img: zapier,
    subTitle:
      "App integration platform to help you connect and automate your processes and boost productivity.",
    btnText: "Coming Soon",
    active: true,
  },
  // {
  //   id: 1,
  //   img: hubspot,
  //   subTitle:
  //     "Sales, customer care, marketing, CRM and more. Integrate HubSpot with Snov.io to unlock your potential.",
  //   btnText: "Coming Soon",
  //   active: true,
  // },
  // {
  //   id: 2,
  //   img: pipedrive,
  //   subTitle:
  //     "Sales CRM and pipeline management software to help you successfully track, prioritize, and manage deals.",
  //   btnText: "Coming Soon",
  //   active: true,
  // },

  // {
  //   id: 5,
  //   img: make,
  //   subTitle:
  //     "An integration platform to connect apps and automate workflows with a no-code visual builder.",
  //   btnText: "Coming Soon",
  //   active: true,
  // },
  // {
  //   id: 6,
  //   img: hypersie,
  //   subTitle:
  //     "A platform that automates visual personalization in your email campaigns. Integrate Hyperise with Snov.io to increase conversion rate and grow revenue.",
  //   btnText: "Coming Soon",
  //   active: true,
  // },
  // {
  //   id: 7,
  //   img: linkedhelper,
  //   subTitle:
  //     "LinkedIn automation software and CRM that offers dozens of features to boost your lead generation on LinkedIn.",
  //   btnText: "Coming Soon",
  //   active: true,
  // },
  // {
  //   id: 8,
  //   img: phantombuster,
  //   subTitle:
  //     "A sales platform that can help you automate your sales lead extraction and generate more business leads online.",
  //   btnText: "Coming Soon",
  //   active: true,
  // },
  // {
  //   id: 9,
  //   img: weblium,
  //   subTitle:
  //     "An easy solution for building websites that attract clients. Collect leads and automate sales by integrating Snov.io with Weblium.",
  //   btnText: "Coming Soon",
  //   active: true,
  // },
  // {
  //   id: 10,
  //   img: salesforce,
  //   subTitle:
  //     "World’s leading CRM with an extensive feature set covering everything from lead generation to partner management.",
  //   btnText: "Coming Soon",
  //   active: true,
  // },
];
// data: 'grant_type=client_credentials'
const Integration = () => {
  const [active, setActive] = useState("");
  const [connected, setConnected] = useState(false);
  const [calendStatus, setCalendStatus] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [showToaster, setShowToaster] = useState(false);
  const [open, setOpen] = useState(false);
  const [loaderStatus, setLoaderStatus] = useState(true);
  // const handleApi = () => {
  // const options = {
  //     method: 'POST',
  //     url: 'https://auth.calendly.com/oauth/token',
  //     headers: {
  //         'Content-Type': 'application/x-www-form-urlencoded',
  //         'Authorization': 'Basic QnJBZ3F5UWpDcGg1MWxxLVRCa24ySVBuVE1MQ2VuYUwzazQ2aGF2bGo0TTozZHlpNXhWTF94aDlvMVN5OHprazhhRkc3WFVuN2M5TTVpQVRLUjVhOVdr'
  //     },
  //     data: 'grant_type=client_credentials'
  // };
  // axios.request(options)
  //     .then(function (response) {
  //         console.log(response.data);
  //     })
  //     .catch(function (error) {
  //         console.error(error);
  //     });
  // const options = {
  //     method: 'GET',
  //     url: 'https://api.calendly.com/users/dnkjsnsdfih',
  //     headers: {'Content-Type': 'application/json', Authorization: 'Bearer eyJraWQiOiIxY2UxZTEzNjE3ZGNmNzY2YjNjZWJjY2Y4ZGM1YmFmYThhNjVlNjg0MDIzZjdjMzJiZTgzNDliMjM4MDEzNWI0IiwidHlwIjoiSldUIiwiYWxnIjoiRVMyNTYifQ.eyJpc3MiOiJodHRwczovL2F1dGguY2FsZW5kbHkuY29tIiwiaWF0IjoxNjk3Njk3NzUyLCJqdGkiOiI4YTliZGFjZi02OGE1LTRiZDUtYjljYS01ODhkM2FhMWI4MDMiLCJhcHBfdWlkIjoiQnJBZ3F5UWpDcGg1MWxxLVRCa24ySVBuVE1MQ2VuYUwzazQ2aGF2bGo0TSIsImV4cCI6MTY5NzcwNDk1Mn0.WFNu5Q-92Q4HFjcbTSSCQq5ota7yvjREI2SIuHJoVJPWqBX4pxcph3DvLIAgy-Q5Xn95c7ptDXDiHAbHLDGoEA'}
  //   };

  //   axios.request(options).then(function (response) {
  //     console.log("user information success",response.data);
  //   }).catch(function (error) {
  //     console.error("user information error",error);
  //   });
  // }
  function getAllIntegration() {
    const userDetailsFrom = JSON.parse(
      localStorage.getItem("MailSenderuserDetails")
    );
    axios
      .get(
        `${BaseUrl.baseurl}/email-marketing/user/get-user-info-by-id/${
          userDetailsFrom && userDetailsFrom.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${
              userDetailsFrom && userDetailsFrom.token
            }`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          if (response.data.details.CalendlyAddedStatus) {
            setCalendStatus(response.data.details.CalendlyActiveStatus);
            setConnected(true);
          } else {
            setConnected(false);
          }
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setLoaderStatus(false);
      })
      .catch((err) => console.log("Error"));
  }
  useEffect(() => {
    getAllIntegration();
  }, []);
  function connectCalendly() {
    window.location.href =
      "https://calendly.com/oauth/authorize?client_id=tSd93kn8R45mQN9oqWTdjuogB2sNdGmSPnkkFQ8wJFM&redirect_uri=https://app.coldsender.com/Calendly-verify/&response_type=code";
  }
  function pauseCalendly(status) {
    let accData = {
      calendlyStatus: !status,
    };
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/user/update-user-calendly-status/${
          userDetails && userDetails.details._id
        }`,
        accData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setShowToaster(true);
          getAllIntegration();
          toast.success(response.data.message, {
            autoClose: true,
            duration: 3000,
            position: "top-right",
          });
        } else {
          setShowToaster(true);
          toast.error(response.data.message, {
            autoClose: true,
            duration: 3000,
            position: "top-right",
          });
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
      })
      .catch((err) => console.log("Error"));
  }
  function deleteCalendly() {
    axios
      .delete(
        `${BaseUrl.baseurl}/email-marketing/user/delete-user-calendly-details/${
          userDetails && userDetails.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setShowToaster(true);
          getAllIntegration();
          toast.success(response.data.message, {
            autoClose: true,
            duration: 3000,
            position: "top-right",
          });
        } else {
          setShowToaster(true);
          toast.error(response.data.message, {
            autoClose: true,
            duration: 3000,
            position: "top-right",
          });
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setOpen(false);
      })
      .catch((err) => console.log("Error"));
  }
  return (
    
    <div
      style={{
        padding: "16px",
        backgroundColor: "#FFF",
        borderRadius: "6px",
        height: "100%",
        overflowY: "scroll",
        border: "1px solid #DDD",
      }}
    >
      {loaderStatus ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "120px",
          }}
        >
          {" "}
          <Loader />
        </div>
      ) : (
        <ul
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "22px",
          }}
        >
          {data.map((item, idx) => (
            <li
              key={item.id}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                gap: "10px",
                // backgroundColor: active === item.id ? "#D1DFE9" : "#FAFAFA",
                backgroundColor:"#FFFFFF",
                borderRadius: "10px",
                padding: "12px",
                boxShadow: "rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px",
                height: "250px",
                border:
                  active === item.id
                    ? "1px solid #1C485F"
                    : "1px solid transparent",
              }}
            >
              <img
                src={item.img}
                alt=""
                style={{ margin: "14px 0px 26px 0px" }}
              />
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexGrow: 1,
                }}
              >
                <p
                  style={{
                    textAlign: "center",
                    color: "#868686",
                    fontFamily: "Source Sans 3",
                    fontSize: "13px",
                    fontWeight: 400,
                    fontStyle: "normal",
                  }}
                >
                  {item.subTitle}
                </p>
                {item.id === 1 && connected ? (
                  <div className="activebarbox">
                    <div className="activebarboxinside">
                      <div className="activebtnlaftbox">
                        {calendStatus ? (
                          <>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10"
                              height="10"
                              viewBox="0 0 10 10"
                              fill="none"
                            >
                              <circle cx="5" cy="5" r="5" fill="#53D86A" />
                            </svg>
                            Active
                          </>
                        ) : (
                          <>
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="10"
                              height="10"
                              viewBox="0 0 10 10"
                              fill="none"
                            >
                              <circle cx="5" cy="5" r="5" fill="#FF3434" />
                            </svg>
                            Pause
                          </>
                        )}
                      </div>
                      <div style={{ display: "flex", gap: "10px" }}>
                        {calendStatus ? (
                          <svg
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              pauseCalendly(calendStatus);
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M8.875 15.925V4.075C8.875 2.95 8.4 2.5 7.2 2.5H4.175C2.975 2.5 2.5 2.95 2.5 4.075V15.925C2.5 17.05 2.975 17.5 4.175 17.5H7.2C8.4 17.5 8.875 17.05 8.875 15.925Z"
                              stroke="#393939"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M17.5 15.925V4.075C17.5 2.95 17.025 2.5 15.825 2.5H12.8C11.6083 2.5 11.125 2.95 11.125 4.075V15.925C11.125 17.05 11.6 17.5 12.8 17.5H15.825C17.025 17.5 17.5 17.05 17.5 15.925Z"
                              stroke="#393939"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        ) : (
                          <svg
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              pauseCalendly(calendStatus);
                            }}
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                          >
                            <path
                              d="M9.97591 18.3327C14.5783 18.3327 18.3092 14.6017 18.3092 9.99935C18.3092 5.39698 14.5783 1.66602 9.97591 1.66602C5.37354 1.66602 1.64258 5.39698 1.64258 9.99935C1.64258 14.6017 5.37354 18.3327 9.97591 18.3327Z"
                              stroke="#393939"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M7.2832 10.1922V8.80051C7.2832 7.06718 8.5082 6.35884 10.0082 7.22551L11.2165 7.92551L12.4249 8.62551C13.9249 9.49218 13.9249 10.9088 12.4249 11.7755L11.2165 12.4755L10.0082 13.1755C8.5082 14.0422 7.2832 13.3338 7.2832 11.6005V10.1922Z"
                              stroke="#393939"
                              stroke-width="1.5"
                              stroke-miterlimit="10"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                        )}

                        <svg
                          onClick={() => {
                            setOpen(true);
                          }}
                          style={{ cursor: "pointer" }}
                          xmlns="http://www.w3.org/2000/svg"
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="none"
                        >
                          <path
                            d="M17.5 4.98307C14.725 4.70807 11.9333 4.56641 9.15 4.56641C7.5 4.56641 5.85 4.64974 4.2 4.81641L2.5 4.98307"
                            stroke="#393939"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M7.08398 4.14102L7.26732 3.04935C7.40065 2.25768 7.50065 1.66602 8.90898 1.66602H11.0923C12.5007 1.66602 12.609 2.29102 12.734 3.05768L12.9173 4.14102"
                            stroke="#393939"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M15.7077 7.61719L15.166 16.0089C15.0743 17.3172 14.9993 18.3339 12.6743 18.3339H7.32435C4.99935 18.3339 4.92435 17.3172 4.83268 16.0089L4.29102 7.61719"
                            stroke="#393939"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M8.60742 13.75H11.3824"
                            stroke="#393939"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                          <path
                            d="M7.91602 10.416H12.0827"
                            stroke="#393939"
                            stroke-width="1.5"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                ) : (
                  <button
                    onClick={() => {
                      if (item.id === 1) {
                        connectCalendly();
                      }
                      setActive(item.id);
                    }}
                    disabled={item.active}
                    style={{
                      color: "#fff",
                      backgroundColor: item.active ? "#D1DFE9" : "#FF3301",
                      borderRadius: "4px",
                      padding: "7px 12px",
                      outline: "none",
                    }}
                  >
                    {item.btnText}
                  </button>
                )}
              </div>
            </li>
          ))}
        </ul>
      )}

      {showToaster && <ToastContainer />}
      <Modal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modalPopupDelete">
          <div className="modaltext">Confirm Remove</div>
          <div className="modalsubtext">
            Are you sure you want to Remove Calendly?
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
            }}
          >
            <div
              className="cancelbuttonmodal"
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancel
            </div>
            <div
              className="continuebuttonmodal"
              onClick={() => {
                deleteCalendly();
              }}
            >
              Continue
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Integration;
